export const ENVIRONMENTS = {
  PROD: 'production',
};
